import BaseDataProvider from '../../core/BaseDataProvider';

class PersonasDataProvider extends BaseDataProvider {

	getPersonasOptions() {
		return this.get('/api/v1/persona/options/');
	}

	getPersonasList(params = {}) {
		const queryString = this.objectToQueryString(params, true);
		return this.get(`/api/v1/persona/?${queryString}`);
	}
	
	createPersona(data) {
		return this.post('/api/v1/persona/', data);
	}

	updatePersona(id, data) {
		return this.patch(`/api/v1/persona/${id}/`, data);
	}

	deletePersona(id) {
		return this.delete(`/api/v1/persona/${id}/`);
	}

	savePersonaAvatar(imgBlob) {
		return this.imageUpload('/api/v1/persona/avatar/', imgBlob)
	}
	
}

const provider = new PersonasDataProvider();
export default provider;
